module.exports = __webpack_public_path__ + "media/images/fischer_banner/banner__sponsor__skyscraper__left-0b37f3c19c2cce91948c329dedace8ee.png";